<template>
<div id="id_predeterminados_DS">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Reporte Preferencias Arancelarias" class="elevation-1 px-5 py-3">

          <v-card-text>
            <v-card-title>
              <span class="headline"></span>
            </v-card-title>
            <v-form ref="form" lazy-validation>
              <v-container grid-list-md text-xs-center>
                <v-row row wrap>
                  <v-col sm="12" md="10" lg="10">
                    <v-autocomplete v-model="model.reporte_url" :items="
                        list_reportes" :hide-no-data="true" :return-object="false" item-text="reporte" item-value="url" label="Tipo de Reporte" @change="setNombreReporte()" :rules="[rules.required]">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>

                  </v-col>
                </v-row>
                <v-layout row wrap>
                  <v-col s2 m2 l2 v-if="model.reporte_url == '/reportes_ds/roce/' || model.reporte_url == '/reportes_ds/pref_arancelarias/'" style="margin-top:-35px;">
                    <v-radio-group v-model="model.tipo_fecha" >
                      <v-radio label="Fecha Pago Original" value="2" />
                      <v-radio label="Fecha Presentación" value="5" />
                      <v-radio label="Fecha Pago Real" value="10" />
                    </v-radio-group>
                  </v-col>
                  <v-flex s12 m5 l5>
                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                          :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false">
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex s12 m5 l5>
                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                          :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                      </template>
                      <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu2 = false">
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex s12 m2 l2>
                    <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                      <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-row row wrap>
                  <v-col>
                    Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col sm="12" md="10" lg="10">
                    <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green">
                    </v-combobox>
                  </v-col>
                </v-row>
                <v-layout row wrap>
                  <v-flex sm3 m3 l3>
                    <p class="text-left font-weight-bold">Tipo de Operación</p>
                    <v-switch color="primary" label="Importación" v-model="model.opc_impo" value="1" :rules="[verificaTipoOperacion]"></v-switch>
                  </v-flex>
                  <v-flex sm3 m3 l3>
                    <p class="text-left font-weight-bold">&nbsp;</p>
                    <v-switch color="primary" label="Exportación" value="1" v-model="model.opc_expo"></v-switch>
                  </v-flex>
                  <v-flex sm4 m4 l4 v-show="model.reporte_url=='/reportes_ds/roce_contribuciones/'">
                    <p class="text-left font-weight-bold">&nbsp;</p>
                    <v-switch color="primary" label="Incluir contribuciones de rectificación" value="1" v-model="model.contribuciones_rectificacion"></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-show="model.reporte_url=='/reportes_ds/seleccion_automatizada/'">
                  <v-flex sm3 m3 l3>
                    <p class="text-left font-weight-bold">Incluir contribuciones pagadas</p>
                    <v-switch color="primary" :label="model.opc_contribuciones_pagadas==1?'Si':'No'" v-model="model.opc_contribuciones_pagadas" :true-value="1" :false-value="0"></v-switch>
                  </v-flex>                  
                </v-layout>
                <!--v-layout row wrap>
                                        <v-flex s14 m4 l4>
                                            <v-switch color="primary" label="Descripción de Clave" value="1" v-model="model.opc_descripcion" ></v-switch>
                                        </v-flex>
                                    </v-layout-->

                <v-card-text v-show="model.reporte_url=='/reportes_ds/roce_contribuciones/' || model.reporte_url=='/reportes_ds/resumen_financiero_contribuciones/'">
                  <v-container grid-list-md text-xs-center>
                    <span style="font-size:15px;"><strong>Tipo de Pedimento</strong></span>
                    <v-row no-gutters dense style="margin-bottom: -35px;">
                      <v-col cols=3>
                        <v-checkbox color="blue" v-model="model.tipos_pedimento" label="1 - PEDIMENTO" value="1" :rules="[verificaTiposPedimento]"></v-checkbox>
                      </v-col>
                      <v-col cols=3>
                        <v-checkbox color="blue" v-model="model.tipos_pedimento" label="2 - PEDIMENTO RECTIFICADO" value="2"></v-checkbox>
                      </v-col>
                      <v-col cols=3></v-col>
                      <v-col cols=3></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <br />
                <div>&nbsp;</div>

                <v-card-text v-show="model.reporte_url=='/reportes_ds/roce_contribuciones/' || model.reporte_url=='/reportes_ds/resumen_financiero_contribuciones/'">
                  <v-expansion-panels hover>
                    <v-expansion-panel>
                      <v-expansion-panel-header style="font-weight:bold!important;">Apéndice 12: Contribuciones &nbsp;&nbsp;<span style="font-size:12px!important;color:#ff5252!important" v-show="validaContribucion">Seleccione una
                          Contribución</span></v-expansion-panel-header>
                      <v-expansion-panel-content style="margin-top: -25px;">
                        <v-checkbox v-model="selecciona_todo12" label="Seleccionar Todo" @change="seleccionaTodo12()"></v-checkbox>
                        <br />
                        <v-row no-gutters dense>
                          <v-col cols=3 v-for="(forma, index) in arr_contribuciones" :key="'contri'+index">

                            <v-checkbox v-model="model.contribuciones" :label="forma.nombregrupo" :value="forma.clave" :rules="index==0?[verificaContribuciones]:[]">
                            </v-checkbox>

                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header style="font-weight:bold!important;">Apéndice 13: Formas de Pago &nbsp;&nbsp;<span style="font-size:12px!important;color:#ff5252!important" v-show="validaForma">Seleccione una Forma de
                          Pago</span></v-expansion-panel-header>
                      <v-expansion-panel-content style="margin-top: -25px;">
                        <v-checkbox v-model="selecciona_todo13" label="Seleccionar Todo" @change="seleccionaTodo13()"></v-checkbox>
                        <br />
                        <v-row no-gutters dense>
                          <v-col cols=3 v-for="(forma, index) in arr_formas_pago" :key="'formas'+index">
                            <v-checkbox color="purple" v-model="model.formas_pago" :label="forma.clave+' - '+forma.descripcion" :value="forma.clave" :rules="index==0?[verificaFormasPago]:[]"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>

              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="success" @click="generar_reporte_sqs">
              <v-icon>done</v-icon>Generar Reporte DS
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <v-refresh-button :funcion="cargarReportesDS" />
            <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2">
              <template slot="noResults">
                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
              </template>

              <template slot="actions" slot-scope="props">
                <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)">
                  <v-icon dark>get_app</v-icon>
                </v-btn>
                <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </template>
            </v-client-table>
          </v-card-text>

        </base-material-card>


      </v-flex>
    </v-layout>
  </v-container>

  <v-divider></v-divider>

  <v-dialog v-model="dialog1" max-width="500px">
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea con formato: 000-0000-0000000</span><br>
        <small>*Usando esta opción no se tomará en cuenta el rango de fechas</small>
        <v-form ref="formListado" lazy-validation="">
          <small><b>Consulta máxima de 50 pedimentos</b></small>
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.lista=''; lista_filtrada=[]; dialog1 = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  data: () => ({
    dialog1: false,
    lista_filtrada: [],
    refreshTabla: false,
    permisoEliminar: false,
    fab: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "Reportes",
          disabled: true,
          to: ""
      },
      {
        text: "Reportes Predeterminados DS",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    validaContribucion: false,
    validaForma: false,
    validaIdentificador: false,
    selecciona_todo12: false,
    selecciona_todo13: false,
    arr_formas_pago: [],
    arr_contribuciones: [],

    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    show_loading: true,

    list_reportes: [{
        "reporte": "Preferencias Arancelarias",
        "url": "/reportes_ds/pref_arancelarias/"
      },
    ],

    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "",
      nombre_reporte: "",
      contribuciones: [],
      formas_pago: [],
      tipos_pedimento: [],
      tipo: "Predeterminados_DS",
      lista: '',
      opc_impo: 0,
      opc_expo: 0,
      opc_contribuciones_pagadas: 0,
      contribuciones_rectificacion: 0,
      opc_descripcion: 0,
      tipo_fecha:"2"
    },

    menu1: false,
    menu2: false,

    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    }
  }),

  methods: {
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.lista);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.model.fecha_de = "";
      this.model.fecha_a = "";
      this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
      try {
        var newarr = [];
        if (cadena != undefined) {
          let data = cadena.split("\n");
          newarr = data.filter(a => a.trim() !== '');
          for (var i = 0; i < newarr.length; i++) {
            newarr[i] = newarr[i].trim();
            newarr[i] = newarr[i].replace(',', '');
            newarr[i] = newarr[i].replace('.', '');
          }
        }
        return newarr;
      } catch (error) {
        console.log(error);
      }
    },
    verificaTipoOperacion: function() {
      if (this.model.opc_impo != 1 && this.model.opc_expo != 1) {
        return "Seleccione al menos un tipo de operación";
      }
      return true;
    },
    verificaPedimento: function() {
      if (this.model.lista != '' && this.model.lista != null && this.model.lista.length > 0) {
        return true;
      }
      if (this.model.fecha_de == "" || this.model.fecha_a == "") {
        return "Favor de ingresar fechas o listado de pedimentos";
      }
      return true;
    },
    maxListaRule: function() {
      if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
        return "Lista vacia";
      }

      let x = this.model.lista.split("\n");

      if (x.length > 50) {
        return "No se puede consultar mas de 50 pedimentos";
      } else if (x.length > 0) {
        for (var k in x) {
          if (!this.validarPatronPedimento(x[k]))
            return "Verificar pedimentos no válidos. Ejemplo correcto: 240-0123-0000123";
        }
      }

      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida.";
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    verificaTiposPedimento: function() {
      if ((this.model.reporte_url == '/reportes_ds/roce_contribuciones/' || this.model.reporte_url == '/reportes_ds/resumen_financiero_contribuciones/') && this.model.tipos_pedimento.length == 0)
        return "Seleccione un Tipo";
      else
        return true;
    },
    verificaFormasPago: function() {
      if ((this.model.reporte_url == '/reportes_ds/roce_contribuciones/' || this.model.reporte_url == '/reportes_ds/resumen_financiero_contribuciones/') && this.model.formas_pago.length == 0) {
        this.validaForma = true;
        return "Seleccione una Forma";
      } else {
        this.validaForma = false;
        return true;
      }
    },
    verificaContribuciones: function() {
      if ((this.model.reporte_url == '/reportes_ds/roce_contribuciones/' || this.model.reporte_url == '/reportes_ds/resumen_financiero_contribuciones/') && this.model.contribuciones.length == 0) {
        this.validaContribucion = true;
        return "Seleccione una Contribución";
      } else {
        this.validaContribucion = false;
        return true;
      }
    },
    seleccionaTodo12: function() {
      if (this.selecciona_todo12 == true) {
        var thisObj = this;
        this.arr_contribuciones.forEach(e => {
          thisObj.model.contribuciones.push(e.clave);
        });
      } else {
        this.model.contribuciones = [];
      }
    },
    seleccionaTodo13: function() {
      if (this.selecciona_todo13 == true) {
        var thisObj = this;
        this.arr_formas_pago.forEach(e => {
          thisObj.model.formas_pago.push(e.clave);
        });
      } else {
        this.model.formas_pago = [];
      }
    },
    cargarReportesDS: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Predeterminados_DS"
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
            }

            this.datos = this.datos.filter((item) => item.nombre_reporte == "Preferencias Arancelarias");
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes ds.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          var result = "";

          if (params.lista != undefined && params.lista != "" && params.lista.length > 0) {
            result += "Búsqueda por Lista.";
          } else {
            result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          }

          if (params.opc_impo != undefined && params.opc_impo != "")
            result += ", Importaciones: " + (params.opc_impo == 1 ? "Si" : "No");
          if (params.opc_expo != undefined && params.opc_expo != "")
            result += ", Exportaciones: " + (params.opc_expo == 1 ? "Si" : "No");
          if (params.contribuciones_rectificacion != undefined && params.contribuciones_rectificacion != "")
            result += ", Contribuciones Rectificación: " + (params.contribuciones_rectificacion == 1 ? "Si" : "No");

          if (params.opc_descripcion != undefined && params.opc_descripcion != "")
            result += ", Descripción de Clave: " + (params.opc_descripcion == 1 ? "Si" : "No");

          return result;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },

    generar_reporte_sqs() {
      this.verificaContribuciones();
      this.verificaFormasPago();

      if (!this.$refs.form.validate() || this.validaForma == true || this.validaContribucion == true) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        if (this.model.opc_impo != 1)
          this.model.opc_impo = 0;
        if (this.model.opc_expo != 1)
          this.model.opc_expo = 0;
        if (this.model.contribuciones_rectificacion != 1)
          this.model.contribuciones_rectificacion = 0;
        if (this.model.opc_descripcion != 1)
          this.model.opc_descripcion = 0;
        var data = Vue.util.extend({}, this.model); //Clonamos el modelo, para no desagrupar los filtros de contribuciones


        if (data.lista == '' || data.lista == []) {
          delete(data['lista']);
        } else {
          data['lista'] = this.get_array_lista(data['lista']);
          data['fecha_de'] = ""
          data['fecha_a'] = ""
        }

        var contribuciones_flat = []; //Desagrupamos las contribuciones, asi se necesitan para el filtro de la api
        for (var k in this.model.contribuciones) {
          for (var m in this.model.contribuciones[k]) {
            contribuciones_flat.push(this.model.contribuciones[k][m])
          }
        }
        data["contribuciones"] = contribuciones_flat;

        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
            this.$root.$dialogLoader.hide();
          }).then(() => {
            this.model.lista = '';
            this.lista_filtrada = [];
            this.cargarReportesDS();
          });
      }
    },

    //Se deja de usar este método (getFechas), ya que el reporte solo deja máximo 1 año, solo que easí estaba en el sistema anterior
    getFechas: function() {
      var rfc = this.model.rfc
      axios.post(this.$hostname + "reportes/fechas_reporte/", {
          'rfc': rfc
        })
        .then(response => {
          var filtered = response.data;

          if (filtered != null && filtered != undefined) {
            if (String(filtered.ds_inicial) != "")
              this.model.fecha_de = moment(String(filtered.ds_inicial)).format("YYYY-MM-DD");
            if (String(filtered.ds_final) != "")
              this.model.fecha_a = moment(String(filtered.ds_final)).format("YYYY-MM-DD");
          }

        })
        .catch(error => {
          console.log(error);

        });
    },
    cargarFormasPago: function() {
      axios.post(this.$hostname + "apendices/lista/", {
          tabla: 5
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            var datos = res.data;
            datos.sort(function(a, b) {
              //Ordenar por clave ascendente
              return a.clave - b.clave;
            });
            this.arr_formas_pago = datos;

          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las formas de pago.",
            footer: ""
          });
          console.log(err);
        })
    },
    cargarContribuciones: function() {
      axios.post(this.$hostname + "apendices/lista/", {
          tabla: 14
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            var datos = res.data;
            var thisObj = this;
            datos.forEach(e => {
              var index = 0;
              for (var k in thisObj.arr_contribuciones) {
                if (thisObj.arr_contribuciones[k].grupo == e.grupo)
                  index = k;
              }
              if (index == 0) {
                var nombregrupo = e.clave + " - " + e.grupo;
                if (e.clave == "5")
                  nombregrupo = "* - IEPS";

                thisObj.arr_contribuciones.push({
                  "nombregrupo": nombregrupo,
                  "grupo": e.grupo,
                  "clave": [e.clave],
                  "descripcion": e.descripcion
                })
              } else {
                thisObj.arr_contribuciones[index].clave.push(e.clave);
                thisObj.arr_contribuciones[index].descripcion += "  **" + e.clave + " - " + e.descripcion;
              }
            });

          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las claves de contribuciones.",
            footer: ""
          });
          console.log(err);
        })
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    setNombreReporte: function() {
      var url = this.model.reporte_url
      var search = this.list_reportes.filter(function(e) {
        return e.url == url;
      });
      if (search.length > 0) {
        this.model.nombre_reporte = search[0].reporte;
      }
      this.selecciona_todo12 = false;
      this.selecciona_todo13 = false;
      this.seleccionaTodo12();
      this.seleccionaTodo13();
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportesDS();
            });
        }
      });
    },
  }, //methods
  created: function() {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.URL = this.$hostname + "reportes/";
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }

    this.cargarFormasPago();
    this.cargarContribuciones();

    this.cargarReportesDS();


  }
};
</script>
<style scoped>
.elevation-1>>>.vl {
  border-left: 1px solid gray;
  height: auto;
}

.elevation-1>>>.v-label.theme--light {
  color: black !important;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control {
  margin-bottom: -35px;
}

.elevation-1>>>.v-input--has-state>div:nth-child(1)>div:nth-child(2) {
  margin-top: -10px;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light {
  font-size: 10px !important;
}
</style>
